import { PriceListVolumeDiscountsDeleteResponseType } from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const usePriceListVolumeDiscountsDelete = (
  priceListId: number,
  id: number,
) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: () =>
      apiV2Request({
        user,
        business,
        method: "delete",
        path: `price-lists/${priceListId}/volume-discounts/${id}`,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as PriceListVolumeDiscountsDeleteResponseType,
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          business?.id,
          ServerStateKeys.PriceTierVolumeDiscounts,
          priceListId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTiers],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.VolumeDiscounts],
      });
    },
  });
};
